import { createSafeContext } from '@mews-framework/utils';
import { ModuleManager } from '../../moduleManager';

export const { ModuleManagerContextProvider, useModuleManagerContext: useModuleManager } = createSafeContext<
    'ModuleManagerContext',
    ModuleManager
>('ModuleManagerContext');
